import { render, staticRenderFns } from "./DetailRmaListProduct.vue?vue&type=template&id=1387cc7a&scoped=true&"
import script from "./DetailRmaListProduct.vue?vue&type=script&lang=js&"
export * from "./DetailRmaListProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1387cc7a",
  null
  
)

export default component.exports